import { FC, ReactNode } from 'react';
import {
	Box,
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionPanel,
	AccordionIcon,
	VStack,
	useAccordionItemState,
} from 'src/components/ui';
import { InfoIcon } from '@chakra-ui/icons';

interface CampaignSectionProps {
	title: string;
	isOpen: boolean;
	accordionContent: ReactNode;
	extraInformation?: ReactNode;
	onToggle?: () => void | Promise<void>;
	isDisabled?: boolean;
	stepIdx: number;
	infoMessage?: string;
}

const CampaignSection: FC<CampaignSectionProps> = ({
	title,
	isOpen,
	accordionContent,
	extraInformation,
	onToggle,
	isDisabled = false,
	stepIdx,
	infoMessage,
}) => {

	return (
		<VStack spacing={0} mb={5}>
			<Accordion
				allowToggle={!isDisabled}
				index={isOpen && !isDisabled ? 0 : -1}
				boxShadow="0px 0px 15px -3px rgba(0, 0, 0, 0.25)"
				borderRadius="8px"
				borderWidth="1px"
				borderColor={isDisabled ? 'gray.100' : 'gray.100'}
				w="full"
				onChange={() => onToggle?.()}
			>
				<AccordionItem border="none">
					{({ isExpanded }) => (
						<>
							<AccordionButton
								borderRadius="10px"
								_hover={{ bg: 'inherit' }}
								opacity={isDisabled ? 0.6 : 1}
								cursor={isDisabled ? 'default' : 'pointer'}
								data-testid={'campaign-stepper-' + stepIdx}
							>
								<Box
									py={5}
									px={2}
									flex="1"
									textAlign="left"
									fontWeight="bold"
									fontSize="lg"
									color={isExpanded ? 'black' : 'gray.500'}
								>
									{title}
								</Box>
								<AccordionIcon boxSize={6} />
							</AccordionButton>
							{infoMessage && isExpanded && (
								<Box
									mx={4}
									mb={3}
									p={3}
									bg="blue.50"
									borderRadius="md"
									border="1px solid"
									borderColor="blue.100"
								>
									<Box
										fontSize="sm"
										color="gray.700"
										lineHeight="1.6"
										display="flex"
										alignItems="flex-start"
										gap={2}
									>
										<InfoIcon color="blue.500" boxSize={4} mt={0.5} flexShrink={0} />
										<Box>{infoMessage}</Box>
									</Box>
								</Box>
							)}
							<AccordionPanel pb={4} px={0}>
								<Box px={4}>{accordionContent}</Box>
							</AccordionPanel>
						</>
					)}
				</AccordionItem>
			</Accordion>
			{extraInformation && (
				<Box
					w="95%"
					bg="white"
					borderWidth="1px"
					borderColor="gray.100"
					borderRadius="0 0 8px 8px"
					boxShadow="0px 0px 15px -3px rgba(0, 0, 0, 0.25)"
					clipPath="inset(0 -10px -10px -10px)"
				>
					{extraInformation}
				</Box>
			)}
		</VStack>
	);
};

export default CampaignSection;
